function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "04_Icons/base/Close2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Invisible_shape",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "Outline",
  transform: "translate(3.000000, 3.000000)",
  fill: "#00172E",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9,-3.19583824 C9.31379815,-3.19583824 9.57358314,-2.96458036 9.6182234,-2.66319616 L9.625,-2.57083824 L9.625,20.5708382 C9.625,20.9160162 9.34517797,21.1958382 9,21.1958382 C8.68620185,21.1958382 8.42641686,20.9645804 8.3817766,20.6631962 L8.375,20.5708382 L8.375,-2.57083824 C8.375,-2.91601621 8.65482203,-3.19583824 9,-3.19583824 Z",
  id: "Path",
  transform: "translate(9.000000, 9.000000) rotate(-45.000000) translate(-9.000000, -9.000000) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.5708382,8.375 C20.9160162,8.375 21.1958382,8.65482203 21.1958382,9 C21.1958382,9.31379815 20.9645804,9.57358314 20.6631962,9.6182234 L20.5708382,9.625 L-2.57083824,9.625 C-2.91601621,9.625 -3.19583824,9.34517797 -3.19583824,9 C-3.19583824,8.68620185 -2.96458036,8.42641686 -2.66319616,8.3817766 L-2.57083824,8.375 L20.5708382,8.375 Z",
  id: "Path",
  transform: "translate(9.000000, 9.000000) rotate(-45.000000) translate(-9.000000, -9.000000) "
})));
function SvgClose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "04_Icons/base/Close2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose2);
export default __webpack_public_path__ + "static/media/Close2.5c42b0008cf9be15cb2d1e46bd30b03d.svg";
export { ForwardRef as ReactComponent };